export const downloadCategories = [
    {
        id: 'syllabus',
        title: 'Syllabus',
        description: 'Latest curriculum and scheme for B.Tech and MCA programs.',
        icon: 'BookOpen',
        items: [
            { title: 'B.Tech CS 2019 Scheme', size: '1.2 MB', date: '2023-09-15' },
            { title: 'B.Tech EC 2019 Scheme', size: '1.1 MB', date: '2023-09-15' },
            { title: 'B.Tech EEE 2019 Scheme', size: '1.3 MB', date: '2023-09-15' },
            { title: 'MCA 2020 Scheme', size: '0.9 MB', date: '2023-10-10' },
        ]
    },
    {
        id: 'forms',
        title: 'Forms & Documents',
        description: 'Commonly used institutional forms for students and staff.',
        icon: 'FileText',
        items: [
            { title: 'Condonation Application Form', size: '245 KB', date: '2024-01-20' },
            { title: 'Transfer Certificate Request', size: '180 KB', date: '2023-11-05' },
            { title: 'Internal Exam Re-evaluation', size: '210 KB', date: '2024-02-12' },
            { title: 'Hostel Admission Form', size: '320 KB', date: '2024-01-15' },
        ]
    },
    {
        id: 'calendar',
        title: 'Academic Calendar',
        description: 'Important dates for semesters, exams, and holidays.',
        icon: 'Calendar',
        items: [
            { title: 'KTU Academic Calendar 2024-25', size: '560 KB', date: '2024-05-01' },
            { title: 'College Event Calendar 2024', size: '420 KB', date: '2024-01-10' },
        ]
    },
    {
        id: 'exam',
        title: 'Examination',
        description: 'Timetables, notifications, and results archives.',
        icon: 'ClipboardCheck',
        items: [
            { title: 'Series Exam Timetable - June 2024', size: '150 KB', date: '2024-05-20' },
            { title: 'Lab Exam Schedule - S4 CS', size: '120 KB', date: '2024-05-25' },
        ]
    },
    {
        id: 'mandatory-disclosure',
        title: 'Mandatory Disclosure',
        description: 'Mandatory AICTE and institutional disclosures.',
        icon: 'Shield',
        items: [
            { title: 'Mandatory Disclosure 2024-25', size: '2.5 MB', date: '2024-03-01' },
            { title: 'AICTE Approval Documents', size: '4.1 MB', date: '2023-08-15' },
        ]
    }
];
